/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantConfigurationsMetadata } from '../../models/tenant-configurations-metadata';

export interface GetTenantConfigurations$Params {
  'Active-Tenant-Identifier': string;
}

export function getTenantConfigurations(http: HttpClient, rootUrl: string, params: GetTenantConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantConfigurationsMetadata>> {
  const rb = new RequestBuilder(rootUrl, getTenantConfigurations.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantConfigurationsMetadata>;
    })
  );
}

getTenantConfigurations.PATH = '/tenant-configurations';
